import { API_URL_ARTIST } from "@constants/env";
import { getLabelName } from "@helpers/artist.helper";
import useApiCall from "@hooks/Shared/useApiCall";
import { IArtist } from "@interfaces/artist";
import { ISelect } from "@interfaces/Shared/select";

const useGetSelectArtists = () =>
  useApiCall<ISelect[]>({
    url: API_URL_ARTIST,
    params: {
      limit: 5000,
      sort: "artistName",
    },
    transformResponse: [
      (data) => {
        let response = JSON.parse(data) as IArtist[];

        const artists: ISelect[] = response.map(
          ({ artistName, ensName, walletAddress }) => ({
            value: walletAddress,
            label: getLabelName(walletAddress, artistName, ensName),
          })
        );

        return artists;
      },
    ],
  });

export default useGetSelectArtists;
